module.exports = __webpack_public_path__ + "static/helpview-027d0708b3c268ad7907b998848fffd0.jpg";